import React from 'react'
import * as S from './CatalogSelectorBlock.styled'
import HamburgerButton from '../HamburgerButton/HamburgerButton'
import Search from '../Search/Search'
import LogoHeader from '../LogoHeader/LogoHeader'
import dynamic from 'next/dynamic'

const BasketNavigation = dynamic(() => import('../BasketNavigation/BasketNavigation'), {
    ssr: false
})

const CatalogSelectorBlock = () => {
    return (
        <S.Container>
            <S.FirstBlock>
                <LogoHeader />
                <HamburgerButton />
            </S.FirstBlock>
            <S.LastBlock>
                <Search />
                <BasketNavigation />
            </S.LastBlock>
        </S.Container>
    )
}

export default CatalogSelectorBlock
